import React from "react";
import { useTranslation } from "react-i18next";
import Button from "shared/components/FormElements/Button";

import "./FormFooter.css";

const FormFooter = ({
  onUpdate,
  onDelete,
  isUpdating,
  disabled,
  cta,
  isNewItem = false,
  style = {},
  deleteText = null,
  extraActions = null,
}) => {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <div className="footer-container" style={{ ...style }}>
        <div className="update-container">
          <Button type="button" isLoading={isUpdating} disabled={disabled} onClick={onUpdate}>
            {cta ? cta : isNewItem ? t("submit") : t("update")}
          </Button>
        </div>

        <div className="footer-actions-right">
          {extraActions}
          {!isNewItem && (
            <Button type="button" size="small" danger onClick={onDelete}>
              {deleteText ? deleteText : t("delete")}
            </Button>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default FormFooter;
